import { z } from 'zod';
import { percentageSchema } from '../../validation';

//* activity type
export const locationTrackingActivityTypeSchema = z.enum([
  'still',
  'on_foot',
  'walking',
  'running',
  'in_vehicle',
  'on_bicycle',
  'unknown',
]);
export type LocationTrackingActivityType = z.infer<typeof locationTrackingActivityTypeSchema>;

//* user activity
export const locationTrackingActivitySchema = z.object({
  /** the type of user activity such as:
   * - `still` = not moving
   * - `on_foot` = standing on foot
   * - `walking` = walking
   * - `running` = running
   * - `in_vehicle` = moving in vehicle
   * - `on_bicycle`= moving on bicycle
   * - `unknown` = not sure
   */
  type: locationTrackingActivityTypeSchema,
  /** the confidence accuracy of the type `activity type`.
   *
   *  If `1` then it means it's 100% confident of the activity type.
   */
  confidence: percentageSchema,
});
export type LocationTrackingActivity = z.infer<typeof locationTrackingActivitySchema>;
